// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"0744f023","275":"f52a334f","483":"cb0af835","492":"9a59e526","909":"85cd0ee4"}[chunkId] + ".chunk.css";
};